import {PayloadAction} from '@reduxjs/toolkit';
import {IUploadStoreState} from './IUploadStoreState';

export const uploadReducer = {
  clearSubmitStatus: (state: IUploadStoreState, action: PayloadAction<'file' | 'scormPackage' | 'webLink'>) => {
    state[action.payload].page.submitStatus = 'idle';
  },
};
